/** The token SizeType catalog, exposed to template.js before it loads. */
export const CREATURE_SIZE_TYPES = [
    { item_id: '13456FEC-A2EE-DB46-5829-0EB2F627E1B7', variable_name: 'tiny',       weight_multiplier: 3, base_size: 2.5, thumbnail_width: 40 },
    { item_id: 'AAC1F466-7A8B-C593-1ADC-FC402B8909D7', variable_name: 'small',      weight_multiplier: 7, base_size: 3.75, thumbnail_width: 60 },
    { item_id: 'DC23AA88-CB3D-EA4E-F6F7-6389ABC4F9DC', variable_name: 'medium',     weight_multiplier: 10, base_size: 5,   thumbnail_width: 80 },
    { item_id: '52FFDB16-A991-C8D4-FE59-7C75EE6CF7AD', variable_name: 'large',      weight_multiplier: 20, base_size: 10,  thumbnail_width: 160 },
    { item_id: 'D0EF6D7A-82BC-1E6E-9D36-5004C7E0561C', variable_name: 'huge',       weight_multiplier: 40, base_size: 15,  thumbnail_width: 240 },
    { item_id: 'CEA2946E-D395-46EA-A6E7-74D21EA2376E', variable_name: 'gargantuan', weight_multiplier: 80, base_size: 20,  thumbnail_width: 320 },
    { item_id: 'C94CDD74-8ACD-26B0-5C53-4CA29CF21D68', variable_name: 'colossal',   weight_multiplier: 160, base_size: 25,  thumbnail_width: 400 },
    { item_id: '4C33FD22-5382-15DA-1C46-F57F14378AFD', variable_name: 'titanic',    weight_multiplier: 320, base_size: 30,  thumbnail_width: 480 },
];


// SizeType is shared by template.js and the movement engine; no radius ratios.
export const SIZE_TIER_FT = CREATURE_SIZE_TYPES.map(size => size.base_size);
const EPS = 1e-6;
function sizeIndex(baseFt) {
  let index = -1;
  SIZE_TIER_FT.forEach((tier, i) => { if (tier <= baseFt + EPS) index = i; });
  return index;
}
/** Effective space after squeeze_size_category_offset, floored at Tiny. */
export function squeezeBodyFt(baseFt, offset) {
  const index = sizeIndex(baseFt), steps = Math.trunc(offset);
  return steps > 0 && index >= 0 ? Math.min(baseFt, SIZE_TIER_FT[Math.max(0, index - steps)]) : baseFt;
}
/** The gap must fit the holder, one smaller size, or two smaller sizes. */
export function squeezeTier(creatureSize, gapWidthFt) {
  if (!(creatureSize > 0) || !Number.isFinite(creatureSize) || !Number.isFinite(gapWidthFt)) return 'blocked';
  if (gapWidthFt + EPS >= creatureSize) return 'normal';
  const index = sizeIndex(creatureSize);
  for (let steps = 1; steps <= Math.min(2, index); steps++) {
    if (gapWidthFt + EPS >= SIZE_TIER_FT[index - steps]) return steps === 1 ? 'squeezed' : 'very_squeezed';
  }
  return 'blocked';
}
